module.exports = __webpack_public_path__ + "img/reset.d858d616.png";